enum ResponseType {
    ArrayBuffer = 'arrayBuffer',
    Blob = 'blob',
  }
  
  export { ResponseType };